export default __webpack_public_path__ + "static/media/circle-pencil.7a05610b.svg";